import { defineMessages } from 'react-intl';

export default defineMessages({
	lblSearchTitle: {
		id: 'app.customerAccounts.searchTitle',
		defaultMessage: 'Customer Accounts',
	},
	lblSearchOperatorLabel: {
		id: 'app.customerAccounts.searchOperatorLabel',
		defaultMessage: 'Select the account group',
	},
	lblSearchOperatorTooltip: {
		id: 'app.customerAccounts.searchOperatorTooltip',
		defaultMessage: 'Select the account the customer is registered with',
	},
	lblSearchOperatorEmptyPlaceholder: {
		id: 'app.customerAccounts.searchOperatorEmptyPlaceholder',
		defaultMessage: 'None',
	},
	lblSearchEmailLabel: {
		id: 'app.customerAccounts.searchEmailLabel',
		defaultMessage: 'Customer email address',
	},
	lblSearchEmailTooltip: {
		id: 'app.customerAccounts.searchEmailTooltip',
		defaultMessage: 'Search by the customer’s registered email address',
	},
	lblSearchEmailError: {
		id: 'app.customerAccounts.searchEmailError',
		defaultMessage:
			'The email address cannot be found. Please check the details and try again.',
	},
	lblSearchTabEmail: {
		id: 'app.customerAccounts.searchTabEmail',
		defaultMessage: 'Search by email',
	},
	lblSearchTabAccountId: {
		id: 'app.customerAccounts.searchTabAccountId',
		defaultMessage: 'Search by Account ID',
	},
	lblSearchAccountIdLabel: {
		id: 'app.customerAccounts.searchAccountIdLabel',
		defaultMessage: 'Account ID',
	},
	lblSearchAccountIdTooltip: {
		id: 'app.customerAccounts.searchAccountIdTooltip',
		defaultMessage: 'Search by the customer’s account ID',
	},
	lblSearchAccountIdError: {
		id: 'app.customerAccounts.searchAccountIdError',
		defaultMessage:
			'The Account ID cannot be found. Please check the details and try again.',
	},
	lblSearchSubmitButton: {
		id: 'app.customerAccounts.searchSubmitButton',
		defaultMessage: 'Find customer account',
	},
	lblDetailsTitle: {
		id: 'app.customerAccounts.detailsTitle',
		defaultMessage: 'Customer Details',
	},
	lblDetailsCloseButton: {
		id: 'app.customerAccounts.detailsCloseButton',
		defaultMessage: 'Close',
	},
	lblBookingsTitle: {
		id: 'app.customerAccounts.bookingsTitle',
		defaultMessage: 'Bookings',
	},
	lblBookingsAllTab: {
		id: 'app.customerAccounts.bookingsAllTab',
		defaultMessage: 'All',
	},
	lblBookingsActiveTab: {
		id: 'app.customerAccounts.bookingsActiveTab',
		defaultMessage: 'Active',
	},
	lblBookingsUsedTab: {
		id: 'app.customerAccounts.bookingsUsedTab',
		defaultMessage: 'Used',
	},
	lblBookingsTabButtonAreaLabel: {
		id: 'app.customerAccounts.bookingsTabButtonAreaLabel',
		defaultMessage: 'Bookings tab button',
	},
	lblActiveBookingsEmptyState: {
		id: 'app.customerAccounts.activeBookingsEmptyState',
		defaultMessage: 'There are no active bookings.',
	},
	lblUsedBookingsEmptyState: {
		id: 'app.customerAccounts.usedBookingsEmptyState',
		defaultMessage: 'There are no used bookings.',
	},
	lblBookingsEmptyState: {
		id: 'app.customerAccounts.bookingsEmptyState',
		defaultMessage: 'There are no upcoming or past bookings for this account.',
	},
	lblBookingsCreateBookingButton: {
		id: 'app.customerAccounts.bookingsCreateBookingButton',
		defaultMessage: 'Create new booking',
	},
	lblBookingsShowingCount: {
		id: 'app.customerAccounts.bookingsShowingCount',
		defaultMessage: 'Showing {shown} of {total}',
	},
	lblSmartCardsTitle: {
		id: 'app.customerAccounts.smartCardsTitle',
		defaultMessage: 'Smartcards',
	},
	lblEVouchersTitle: {
		id: 'app.customerAccounts.eVouchersTitle',
		defaultMessage: 'eVouchers',
	},
	lblSearchAccountNotFound: {
		id: 'app.customerAccounts.searchAccountNotFound',
		defaultMessage:
			'No account found for this email address. You can create a new customer account.',
	},
	lblCreateAccountButton: {
		id: 'app.customerAccounts.createAccountButton',
		defaultMessage: 'Create new customer account',
	},
	lblCreateAccountDialogTitle: {
		id: 'app.customerAccounts.createAccountDialogTitle',
		defaultMessage: 'Create an account',
	},
	lblCreateAccountFirstName: {
		id: 'app.customerAccounts.createAccountFirstName',
		defaultMessage: 'First name',
	},
	lblCreateAccountLastName: {
		id: 'app.customerAccounts.createAccountLastName',
		defaultMessage: 'Last name',
	},
	lblCreateAccountEmail: {
		id: 'app.customerAccounts.createAccountEmail',
		defaultMessage: 'Email address',
	},
	lblCreateAccountConfirmEmail: {
		id: 'app.customerAccounts.createAccountConfirmEmail',
		defaultMessage: 'Confirm email address',
	},
	lblCreateAccountSubmit: {
		id: 'app.customerAccounts.createAccountSubmit',
		defaultMessage: 'Create account',
	},
	lblCreateAccountCancel: {
		id: 'app.customerAccounts.createAccountCancel',
		defaultMessage: 'Cancel',
	},
	lblCreateAccountSuccess: {
		id: 'app.customerAccounts.createAccountSuccess',
		defaultMessage: 'Customer account created successfully.',
	},
	lblCreateAccountError: {
		id: 'app.customerAccounts.createAccountError',
		defaultMessage: 'Failed to create customer account. Please try again.',
	},
	lblCreateAccountEmailExists: {
		id: 'app.customerAccounts.createAccountEmailExists',
		defaultMessage: 'An account with this email address already exists.',
	},
	lblCreateAccountAlertMessage: {
		id: 'app.customerAccounts.createAccountAlertMessage',
		defaultMessage:
			'An email will be sent to the customer to create a password of their choosing. Ensure the customer is aware they need to follow the actions in this email to access their account online.',
	},
	lblCreateAccountAgeConfirmation: {
		id: 'app.customerAccounts.createAccountAgeConfirmation',
		defaultMessage: 'Please tick to confirm if you are over 16 years old.',
	},
	lblCreateAccountMarketingConsent: {
		id: 'app.customerAccounts.createAccountMarketingConsent',
		defaultMessage:
			'Send me relevant marketing material based on my travel activity.',
	},
	lblCreateAccountTerms: {
		id: 'app.customerAccounts.createAccountTerms',
		defaultMessage:
			"By creating an account you are agreeing to {tocName}'s {termsLink}.",
	},
	lblCreateAccountTermsLink: {
		id: 'app.customerAccounts.createAccountTermsLink',
		defaultMessage: 'terms and conditions',
	},
	errFirstNameEmpty: {
		id: 'app.customerAccounts.errFirstNameEmpty',
		defaultMessage: 'First name is required',
	},
	errFirstNameTooLong: {
		id: 'app.customerAccounts.errFirstNameTooLong',
		defaultMessage: 'First name is too long (maximum 255 characters)',
	},
	errLastNameEmpty: {
		id: 'app.customerAccounts.errLastNameEmpty',
		defaultMessage: 'Last name is required',
	},
	errLastNameTooLong: {
		id: 'app.customerAccounts.errLastNameTooLong',
		defaultMessage: 'Last name is too long (maximum 255 characters)',
	},
	errEmailEmpty: {
		id: 'app.customerAccounts.errEmailEmpty',
		defaultMessage: 'Email address is required',
	},
	errEmailInvalid: {
		id: 'app.customerAccounts.errEmailInvalid',
		defaultMessage: 'Please enter a valid email address',
	},
	errEmailTooLong: {
		id: 'app.customerAccounts.errEmailTooLong',
		defaultMessage: 'Email address is too long (maximum 255 characters)',
	},
	errConfirmEmailEmpty: {
		id: 'app.customerAccounts.errConfirmEmailEmpty',
		defaultMessage: 'Please confirm your email address',
	},
	errConfirmEmailMismatch: {
		id: 'app.customerAccounts.errConfirmEmailMismatch',
		defaultMessage: 'Email addresses do not match',
	},
});
